import React from 'react'
import welcome from "../../../plateform/assets/Illustrations/welcome-removebg-preview.png"
import ButtonBlack from '../../../components/Buttons/ButtonBlack'
import { useNavigate } from 'react-router-dom'

const Welcome = () => {
  const navigate = useNavigate()

  return (
<div className="w-full p-4 md:p-6 space-y-8 sm:p-8 bg-white rounded-lg shadow mt-6 ">
  <div className="flex justify-center">
    <img src={welcome} alt="" className='w-60' />
  </div>
  <h2 className='text-2xl md:text-4xl font-semibold text-center'>Bienvenue sur Mira!</h2>
  <p className='px-10 text-center'>
    Nous sommes ravis de vous accueillir sur Mira, votre plateforme dédiée à la gestion simplifiée des rendez-vous et services. 
    Naviguez en toute simplicité et profitez de nos fonctionnalités!
  </p>
  <ButtonBlack className='w-80 mx-auto  text-white py-2 px-4 rounded-sm ' onClick={navigate('/login')}>Terminer</ButtonBlack>
</div>

  )
}

export default Welcome